import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getUserCases, getExpireDate, getCurrentUser, updateUserLastAction, getAppUser, createFactviewAICase} from '../../functions/utils'; // Import the utility function
import '../../css/ImportComponent.css';
import ImportHeaderComponent from '../page/ImportHeaderComponent';
import DropdownComponent from '../utilities/DropdownComponent';
import CalendarComponent from '../utilities/CalendarComponent';
import ListComponent from '../utilities/ListComponent';
import InvoiceComponent from '../utilities/InvoiceComponent';
import LoaderComponent from '../utilities/LoaderComponent';
import TwinfieldLogo from '../../images/TwinfieldLogo.png';
import { useTranslations  } from '../utilities/TranslationContext';
import {handleImport, updateImportTwinfield, deleteImportTwinfield, updateImportFactviewTokens, getInvoices, getTwinfieldLink} from '../../functions/twinfield';

// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { executeCaseQuery } from '../../functions/import';
import { UsingJoinColumnIsNotAllowedError } from 'typeorm';

// Add the icons you will use to the library
library.add(faChevronDown, faXmark, faArrowLeft);

const TwinfieldComponent = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const [devUser, setDevUser] = useState(false);
  const [userCases, setUserCases] = useState([]);
  const [division, setDivision] = useState([]);
  const [budgetScenario, setBudgetScenario] = useState([]);
  const [importTwinfield, setImportTwinfield] = useState([]);
  const [isExtraContentVisible, setExtraContentVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  
  const [currentMe, setCurrentMe] = useState(false);
  const { getTranslation } = useTranslations();
  
  // Import_exact variables
  const [selectedCase, setSelectedCase] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedAdministration, setSelectedAdministration] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState('act');
  const [selectedBudgetScenario, setSelectedBudgetScenario] = useState(false);
  const [selectedOpeningBalance, setSelectedOpeningBalance] = useState(1);
  const [selectedIgnoreYearEnd, setSelectedIgnoreYearEnd] = useState(0);

  useEffect(() =>{
    // Parse query parameters from the URL
    const queryParams = new URLSearchParams(window.location.search);
    // Handle Exact Online authorization process through query params
    if(queryParams.get("code")){
      const authExpiration = getExpireDate(5);
      document.cookie = `twinfield_auth=${queryParams.get("code")};expires=`+authExpiration+`;path=/`;
      document.cookie = `twinfield_session=${queryParams.get("session_state")};path=/`;
      twinfield_auth(queryParams.get("code")).then(response =>{
        init();
      });
    }
    else {
      setIsLoading(true);
      init();
    }
  },[]);

  useEffect(() =>{
    if(division.length > 0 && selectedAdministration){
      console.log(division.filter(item => item.Code == selectedAdministration)[0].Description);
    }
    if(userCases.length > 0 && selectedCase){
      console.log(userCases.filter(item => item.id == selectedCase)[0]);
    }
  }, [userCases, importTwinfield, division]); // [] makes sure that this useEffect block only runs on the first render of the component

  useEffect(() =>{
  },[devUser, currentMe, selectedBudgetScenario, selectedDataset]);
  
  // Handles the initial exact online setup
  async function init(){ 
    if(await getCurrentUser()){
      const currentMe = await validateToken();
 
      setCurrentMe(currentMe);
      if(currentMe){ 
        handleInvoice(currentMe);
        var cases = await getUserCases();
        await setUserCases(cases);
        await get_office(currentMe, cases);
        setBudgetScenario([{Description: "actuals/realisatiecijfers", Code: "act"}, {Description: "Budget", Code: "budget"}]);
        setSelectedDataset("act");
        setDevUser(await getCurrentUser());
      }
    }
    else{
      setTimeout(function(){
        init();
      },500);
    }
  }

  async function twinfield_get(){
    window.location.href = "https://login.twinfield.com/auth/authentication/connect/authorize?response_type=code&client_id=FactviewImport&redirect_uri=https%3A%2F%2Fimportmodule.factview.nl%2Fapp%3Fimport%3Dtwinfield&scope=openid+twf.user+twf.organisation+twf.organisationUser+offline_access&&state=1&nonce=1&output=embed";
  }

  // Fetch exactonline by authcode
  async function twinfield_auth(code){
    try { 
      const response = await fetch('/twinfield/auth?authcode='+code);
      if (response.ok) {
        const responseData = await response.json();

        if(responseData){
          const accessExpiration = getExpireDate(60);
          const refreshExpiration = getExpireDate(13149000);
          await validateToken(responseData["access_token"], responseData["refresh_token"]);
          clearQueryParams(["code", "session_state", "state"]);
          return responseData;
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function validateToken(twinfieldAccess = false, twinfieldRefresh = false){
    const response = await fetch("/twinfield/validateToken", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        currentUser: await getCurrentUser(),
        accessToken: twinfieldAccess,
        refreshToken: twinfieldRefresh,
      }),
    });
    if (response.ok) { 
      try{
        const responseData = await response.json();
        if(responseData){
          if(responseData && responseData.Message){
            await handleRefresh();
          }
          else{ 
            document.cookie = `twinfield_org_id=${responseData["twf.organisationId"]};path=/`;
            document.cookie = `twinfield_user=${responseData["twf.organisationUserCode"]}; path=/`;
            
            await updateImportFactviewTokens(responseData["twf.organisationUserCode"]);
            return responseData;
          }
        }
        else{
          var appUser = await getAppUser();

          if(appUser.integration_twinfield){
            handleRefresh();
          }
          else{
            twinfield_get();
          }
        }
      } catch (error) {
        twinfield_get();
      }
    }
  }
 
  async function handleRefresh(){
    const response = await fetch("/twinfield/refreshTokens?currentUser="+await getCurrentUser());

    if (response.ok) {
      const responseData = await response.json();

      if(responseData){
        const accessExpiration = getExpireDate(60);
        const refreshExpiration = getExpireDate(13149000);
        document.cookie = `twinfield_access_expiration=${accessExpiration};expires=`+accessExpiration+`;path=/`;
        document.cookie = `twinfield_refresh_expiration=${refreshExpiration};expires=`+refreshExpiration+`;path=/`;
        document.cookie = `twinfield_access=${responseData["access_token"]};expires=`+accessExpiration+`;path=/`;
        document.cookie = `twinfield_refresh=${responseData["refresh_token"]};expires=`+refreshExpiration+`;path=/`;
        await init();
      }
      else{
        twinfield_get();
      }
    }
    else{
      twinfield_get();
    }
  }

  async function handleInvoice(currentMe) {
     if(queryParams.get("invoice_nr") && queryParams.get("invoice_code") && queryParams.get("invoice_office")){
      console.log("Fetching invoice");
      fetchInvoice(currentMe, queryParams.get("invoice_office"), queryParams.get("invoice_code"), queryParams.get("invoice_nr"))
    }
  }

  async function fetchInvoice(currentMe, office, code, number){
    if(office && code && number){
      var window2 = window.open("http://google.com",'_blank');
      var response = await fetch('/twinfield/getInvoice', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          currentUser: await getCurrentUser(),
          office: office, 
          code: code,
          number: number,
          twinfieldLink: currentMe["twf.clusterUrl"],
        }),
      });
      var responseData = await response.json();
      if(responseData){
        console.log(responseData);
        if(responseData[0]){
          var invoiceLink = "https://secure.basecone.com/lookup?GUID="+responseData[0].invoice_id;
          window.location.href = invoiceLink;

          window2.location.hfref = "https://secure.basecone.com/lookup?GUID="+responseData[1].invoice_id;
          clearQueryParams(["invoice_office", "invoice_code", "invoice_nr"]);
        }  
        else{
          alert("Voor dit record is er geen factuur beschikbaar in Twinfield!");
          clearQueryParams(["invoice_office", "invoice_code", "invoice_nr"]);
        }      
      }
    }
    else{
      alert("Zorg dat alle velden gevuld zijn!");
    }
  }
  async function get_office(currentMe, cases){
    const response = await fetch("/twinfield/getOffice?clusterUrl="+currentMe["twf.clusterUrl"]+"&twinfieldOrganisation="+currentMe["twf.organisationId"]);

    if (response.ok) {
      const responseData = await response.text();
      if(responseData && responseData != "false"){ 
        const parser = new DOMParser();
        
        const xmlDoc = parser.parseFromString(responseData, "text/xml");

        // Extract ProcessXmlStringResult content
        const processXmlStringResult = xmlDoc.querySelector("ProcessXmlStringResult")?.textContent;
        if (!processXmlStringResult) {
          throw new Error("No ProcessXmlStringResult found");
        }

        const innerParser = new DOMParser();
        const innerXmlDoc = innerParser.parseFromString(processXmlStringResult, "text/xml");
      
        // Extract all <office> elements
        const officeElements = innerXmlDoc.querySelectorAll("office");
        const offices = Array.from(officeElements).map((office, index) => ({
          Description: office.getAttribute("name") || "",
          Code: office.textContent?.trim() || "",
        }));
        await fetchImportTwinfield(offices, cases);
        setDivision(offices);

        return offices;
      }
      else{
        // alert("Twinfield error: probeer na een minute nog een keer");
        twinfield_get();
      }
    }
  }

  async function get_gb(){
    const response = await fetch("/?accessToken="+getCookie("twinfield_access"));
    if (response.ok) {
      const responseData = await response.text();
      
      if(responseData){
      }
    }
  }

  async function newCS(currentUser){
    const response = await fetch("/twinfield/newCS?currentUser="+currentUser);
    console.log(response);
      if (response.ok) {
        const responseData = await response.text();
        console.log(responseData);
        if(responseData){
        }
      }
  }

  // Check if import exact already exists based on selected variables, if not create new import exact
  async function fetchImportTwinfield(divs, cases){
    var divisionArray = [];
    
    var appUser = await getAppUser();
    var importTwinfieldLink = await getTwinfieldLink(appUser.integration_twinfield);

    divs.forEach(function(div){
      divisionArray.push(div.Code);
    });
    
    if(divisionArray.length > 0){
      const response = await fetch('/import_twinfield/getImportTwinfieldDivisions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          division: divisionArray,
          userCases: cases,
          organisation_id: importTwinfieldLink.organisation_id,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        setIsLoading(false);
        setImportTwinfield(responseData);
        
        return responseData;
      } 
    } 
    else{
      setIsLoading(false);
    }
  }

  // Check if import exact already exists based on selected variables, if not create new import exact
  async function handleCreateImport(){
    updateUserLastAction();
    if(selectedCase && selectedAdministration && selectedDataset && selectedYear){
      var exists = false;
      if(importTwinfield){
        for(const imp of importTwinfield){
          if(imp.entiteit == selectedCase+"_1" && imp.year == selectedYear && imp.budget_scenario == selectedDataset && imp.office == selectedAdministration){
            exists = true;
          }
        } 
      }

      if(!exists){
        var officeDesc = await getOfficeDesc(selectedAdministration);
        if(selectedCase == "import_ai"){
         
          var newCase = await createFactviewAICase("importmodule - "+officeDesc, await getCurrentUser());
          console.log(newCase);
          createImportTwinfield(newCase.id);
        }
        else{
          createImportTwinfield();
        }
      }
      else{
        alert("Deze koppeling bestaat al!");
      }
    }
    else{
      alert("Zorg dat alle velden gevuld zijn!");
    }
  }
  // Creates new import exact using user selected variables
  async function createImportTwinfield(caseId = false){
    try{
      var case_id = (caseId) ? caseId : selectedCase;
      const currentMe = await validateToken();
      var appUser = await getAppUser();
      var importTwinfieldLink = await getTwinfieldLink(appUser.integration_twinfield);
      console.log(importTwinfieldLink);
      const response = await fetch('/twinfield/createImportTwinfield', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          entiteit: case_id+"_1",
          jaar: selectedYear,
          office: selectedAdministration,
          office_description: await getOfficeDesc(selectedAdministration),
          budgetScenario: selectedDataset,
          openingBalance: selectedOpeningBalance,
          ignoreYearEnd: selectedIgnoreYearEnd,
          factviewAccess: getCookie('factview_access'),
          factviewRefresh: getCookie('factview_refresh'),
          twinfieldAccess: importTwinfieldLink.access_token,
          twinfieldRefresh: importTwinfieldLink.refresh_token,
          twinfieldLink: currentMe["twf.clusterUrl"],
          twinfieldUser: currentMe["twf.organisationUserCode"],
          twinfieldOrganisation: currentMe["twf.organisationId"],
          currentUser: await getCurrentUser(),
        }),
      })
      if (response.ok) {
        const responseData = await response.json();
        var cases = await getUserCases();
        await fetchImportTwinfield(division, cases);
        await setUserCases(cases);
        resetAllInputs();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function getOfficeDesc(code){
    for(const div of division){
      if(div.Code == code){
        return div.Description;
      }
    }
    return null;
  }

  async function reloadImportTwinfield(){
    setIsLoading(true);
    await fetchImportTwinfield(division, userCases);
  }

  // Toggle On/Off create new import editor
  function toggleEditor(){
    const contentDiv = document.querySelector(".import-create-content");
    const newBtn = document.querySelector(".new-btn");
    const editorBtns = document.querySelector(".import-editor-btns");

    if(contentDiv.classList.contains("hidden")){
      contentDiv.classList.remove("hidden");
      newBtn.classList.add("hidden");
      editorBtns.classList.remove("hidden");
    }
    else{
      contentDiv.classList.add("hidden");
      newBtn.classList.remove("hidden");
      editorBtns.classList.add("hidden");

      resetAllInputs();
    }
  }

  // Toggle the additional import exact options (IgnoreYearEnd, Opening Balance)
  function toggleExtraOptions(){
    const extraContent = document.querySelector(".extra-content");
    const extraIcon = document.querySelector(".toggle-extra-icon");
    const createExtra = document.querySelector(".import-create-extra");
    
    if(!extraContent.classList.contains("visible")){
      extraContent.classList.add("visible");
      setExtraContentVisible(true);
      createExtra.style.maxHeight ="300px";
      createExtra.style.overflow = "visible";
    }
    else{
      extraContent.classList.remove("visible");
      extraIcon.classList.remove("fa-xmark");
      setExtraContentVisible(false);
      createExtra.style.maxHeight ="55px";
      createExtra.style.overflow = "hidden";
      resetExtraDropdown();
    }
  }

  // Resets all input and dropdown input fields to default
  function resetAllInputs(){
    setSelectedYear(new Date().getFullYear());
    setSelectedIgnoreYearEnd(0);

    const resets = document.querySelector(".import-content").querySelectorAll(".reset-dropdown-btn");
    for(const reset of resets){
      reset.click();
    }
  }

  // Resets just the additional option dropdown elements
  function resetExtraDropdown(){
    setSelectedOpeningBalance(1);
    setSelectedIgnoreYearEnd(0);

    const resets = document.querySelector(".extra-content").querySelectorAll(".reset-dropdown-btn");
    for(const reset of resets){
      reset.click();
    }
  }

  // Handle the selectedYear onChange event
  async function handleChange(event){
    const newValue = event.target.value;
    setSelectedYear(newValue);
  }

  async function handleBudgetChange(event){
    var budgetValue = event.target.value;
    setSelectedDataset(budgetValue)
  }

  // Handle the dropdown onSelect events.
  function handleSelect(selectedOption){
    if(selectedOption.type=="case"){
      setSelectedCase(selectedOption.value);
    }
    else if(selectedOption.type=="administration"){
      setSelectedAdministration(selectedOption.value);
    }
    else if(selectedOption.type=="budgetscenario"){
      if(selectedOption.value == "budget"){
        setSelectedDataset("001");
        setSelectedBudgetScenario(selectedOption.value);
      }
      else{
        setSelectedBudgetScenario(false);
        setSelectedDataset(selectedOption.value);
      }
    }
    else if(selectedOption.type=="beginbalans"){
      setSelectedOpeningBalance(selectedOption.value);
    }
    else if(selectedOption.type=="memoriaal"){
      setSelectedIgnoreYearEnd(selectedOption.value);
    }
  } 

  return (
    <div className="import-container">
      <ImportHeaderComponent
        title="Twinfield"
        logo={TwinfieldLogo}
        subtitle={getTranslation('import_TwinfieldSubtitle')}
      />
        <div className="import-component-container">
         <div className="import-component-content">
          <div className="import-content">
            {/* <button className="import-btn invoice-btn hover"  onClick={testImport}>Get Salesinvoice</button> */}
           
            <div className="import-create-content hidden">
              <div className="import-create-basic">
                <div className="case-content">
                  <p>{getTranslation('import_FVCase')}*</p>
                  <DropdownComponent
                    options={userCases.map((userCase) => ({ label: userCase.name, value: userCase.id, type:'case'}))}
                    defaultValue={(!selectedCase)?{ label: getTranslation("import_SelectCase"), value: null, type:null}:{label: userCases.filter(item => item.id === selectedCase)[0].name, value: null, type: null}}
                    onSelect={handleSelect}
                    className="case"
                  />
                </div>
                <div className="administration-content">
                  <p>Twinfield {getTranslation('import_Administration')}*</p>
                  <DropdownComponent
                    options={division.map((div)=>({label: div.Description, value: div.Code, type:'administration'}))}
                    onSelect={handleSelect}
                    defaultValue={(!selectedAdministration)?{ label: getTranslation("import_SelectAdministratie"), value: null, type:null}:{label: division.filter(item => item.Code == selectedAdministration)[0].Description, value: null, type: null}}
                    className="administration"
                  />
                </div>
                <div className="jaar-content">
                  <p>{getTranslation('import_Year')}*</p>
                  <input
                    type="number"
                    min="1000" 
                    max="9999"
                    id="numberInput"
                    className="jaar-input"
                    value={selectedYear}
                    onChange={handleChange}
                  />
                </div>
                <div className="dataset-content">
                  <p>{getTranslation('import_Dataset')}*</p>
                  <DropdownComponent
                    options={budgetScenario.map((scenario) => ({ label: scenario.Description, value: scenario.Code.trim(), type:'budgetscenario'}))}
                    onSelect={handleSelect}
                    defaultValue={{ label:"actuals/realisatiecijfers", value: "act", type:'budgetscenario'}}
                    className="dataset"
                  />
                  {selectedBudgetScenario == "budget" ? (<div><p>{getTranslation('import_BudgetCode')}*</p><input
                    className="budget-input"
                    value={selectedDataset}
                    onChange={handleBudgetChange}
                  /></div>
                  ):null}
                </div>
              </div>
            </div>
          </div>
          <div className="import-menubar">
            <button className="import-btn new-btn hover"  onClick={toggleEditor}>{getTranslation('import_CreateNew')}</button>            
            <div className="import-editor-btns hidden">
              <button className="import-btn submit-btn hover"  onClick={()=>{handleCreateImport(); toggleEditor();}}>{getTranslation('import_Submit')}</button>
              <button className="import-btn cancel-btn hover"  onClick={toggleEditor}>{getTranslation("import_Cancel")}</button>
            </div>
          </div>
          <div className="import-list-content">
            <LoaderComponent isLoading={isLoading} paddingTop={"20px"}/>
            {Array.isArray(importTwinfield) && importTwinfield.length > 0 ? (
              <ListComponent data={importTwinfield} reloadImport={reloadImportTwinfield} importType={"twinfield"} handleImport={handleImport} updateImport={updateImportTwinfield} deleteImport={deleteImportTwinfield}/>
            ):("")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwinfieldComponent;
